import React from "react";
import ct from "class-types.macro";
import Stars from "~/common/Stars";
import { BrandDetail } from "~/common/Store/models/Brand";

const ExpandedBrandHeader = ({
  pageHeader,
  name,
  brandLogo,
  headline,
  overallRating,
  productCount,
  expandedPageAttributes,
}: BrandDetail) => {
  return (
    <div
      data-testid="hero"
      style={{
        background: "#26353C",
        zIndex: 0,
      }}
      className={`${ct(
        "h-auto",
        "max-h-60",
        "overflow-hidden",
        "relative",
        "text-center",
        "xs:-mb-6",
        "lt:mb-0",
        "lt:-mt-6",
      )}`}
    >
      <div
        className={ct(
          "max-h-60",
          "p-6",
          "relative",
          "inset-0",
          "text-left",
          "xs:px-10",
          "lt:flex",
          "lt:items-center",
        )}
      >
        <div
          style={{ maxWidth: "1700px", margin: "0 auto", zIndex: 1 }}
          className={ct(
            "box-border",
            "flex",
            "flex-col",
            "flex-wrap",
            "items-center",
            "max-h-60",
            "text-left",
            "antialiased",
            "w-full",
            "xs:py-10",
            "lt:px-10",
            "lt:py-20",
            "lg:px-16",
            "lz:flex-row",
            "lz:justify-between",
            "xxl:px-32",
          )}
        >
          <div
            className={ct(
              "block",
              "text-center",
              "xs:flex",
              "xs:items-end",
              "xs:items-center",
              "xs:flex-1",
              "xs:text-left",
              "xs:w-full",
              "lz:items-center",
            )}
          >
            <div className="vendor-title__image flex-shrink-0">
              <img src={brandLogo} alt={name} />
            </div>
            <div
              className={ct(
                "inline-block",
                "mt-2",
                "max-w-full",
                "w-full",
                "xs:mb-3",
                "lt:flex-grow",
                "lt:w-26",
                "lz:mb-0",
              )}
            >
              <h1
                style={{ textShadow: "rgba(0, 0, 0, 0.5) 0px 2px 3px" }}
                className={ct(
                  "text-3xl-1/2",
                  "leading-6",
                  "mb-1",
                  "text-center",
                  "text-white",
                  "xs:text-3xl",
                  "xs:mb-2",
                  "xs:text-left",
                  "md:text-4xl",
                  "md:leading-8",
                  "lt:text-5xl",
                  "lt:leading-10",
                )}
              >
                {pageHeader}
              </h1>
              <h2
                data-testid="headlineText"
                style={{
                  textShadow: "rgba(0, 0, 0, 0.5) 0px 2px 3px",
                  margin: 0,
                  fontWeight: "normal",
                }}
                className={ct(
                  "text-sm",
                  "leading-4",
                  "mx-auto",
                  "max-w-75",
                  "text-center",
                  "text-white",
                  "xs:mx-0",
                  "xs:max-w-full",
                  "xs:text-left",
                  "md:text-lg",
                  "md:leading-4",
                  "lt:text-xl",
                  "lt:leading-4",
                )}
              >
                {headline}
              </h2>
            </div>
          </div>
          <div
            style={{
              boxShadow: "0 3px 4px rgb(0 0 0 / 15%)",
              opacity: ".9",
              borderRadius: "4px",
            }}
            className={ct(
              "bg-white",
              "flex",
              "items-center",
              "mt-2",
              "p-2",
              "text-center",
              "text-gray-800",
              "xs:my-4",
            )}
          >
            <div className={ct("hidden", "my-0", "mx-3", "xs:inline-block")}>
              <div
                data-testid="vendorStatValue"
                className={ct("font-semibold", "text-xl")}
              >
                {productCount}
              </div>
              <div className={ct("text-xs", "leading-normal", "uppercase")}>
                PRODUCTS
              </div>
            </div>
            <div className={ct("mx-3")}>
              <div className={ct("block", "mr-1", "top-0")}>
                <Stars rating={overallRating} size="large" />
              </div>
              <div
                className={ct(
                  "text-xs",
                  "leading-normal",
                  "mr-1",
                  "mb-1",
                  "uppercase",
                )}
              >
                AVG RATING
              </div>
            </div>
          </div>
        </div>
        {expandedPageAttributes.headerImage &&
          expandedPageAttributes.headerImage !== "" && (
            <div
              data-testid="hero-image"
              className={`hero-img ${ct(
                "hidden",
                "my-0",
                "mx-auto",
                "max-h-60",
                "absolute",
                "inset-0",
                "w-full",
                "lt:block",
              )}`}
              style={{
                backgroundImage: `url("${expandedPageAttributes.headerImage}")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top center",
                backgroundSize: "cover",
              }}
            />
          )}
      </div>
    </div>
  );
};
export default ExpandedBrandHeader;
